import React from 'react';
import {Basic} from '@packages/systems/core/plugins';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {
  withSystem,
  Plugins,
  Atom,
  type AtomRender,
} from '@packages/systems/wfdl';
import {iconName, typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {
  TList,
  TRecord,
  TElement,
  TTypeConstructor,
  TText,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {EVENT_IDS_ATOM_FIELD} from '@packages/systems/optimization/constants';

const Link = Atom.getConfigShape(Basic.atoms.Link).render as AtomRender;

const DropdownLink = Atom.createRender(({classes, ...rest}) => {
  const linkProps = {
    ...rest,
    classes: classes.push('w-dropdown-link'),
  } as const;

  return <Link {...linkProps} />;
});

const config = createDevlinkAtom({
  displayName: 'Dropdown Link',
  constraints: {
    descendants: SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
    ancestors: [
      {
        is: 'DropdownWrapper',
        rule: 'AtLeastOne',
      },
      {
        is: 'DropdownList',
        rule: 'AtLeastOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Link')),
  },
  showEmpty: false,
  render: DropdownLink,
  fields: {
    dropdown: withSystem(
      {private: true},
      TRecord({
        type: TText,
      })
    ),
    children: withSystem({label: 'Text', isBindable: true}, TList(TElement)),
    link: withSystem(
      {
        label: 'Link',
        isBindable: true,
        defaultValue: {mode: 'external'},
        isLocalizable: true,
      },
      TTypeConstructor(qualify(Plugins.name('Basic'), typeName('Link')))
    ),
    eventIds: EVENT_IDS_ATOM_FIELD,
  },
  autoEngagementTrackingAttribute: true,
});

export default config;
